import { Fragment } from 'react'

import { AssessmentScale, assessmentComponentsRows, Pillar } from 'constants/BrandAssessmentConstants'

const pillarClass: Record<Pillar, string> = {
  'Human Insight': 'pillar-human-insight',
  'Product Edge': 'pillar-product-edge',
  'Brand Edge': 'pillar-brand-edge',
}

const rowTintClass: Record<Pillar, string> = {
  'Human Insight': 'row-tint-human-insight',
  'Product Edge': 'row-tint-product-edge',
  'Brand Edge': 'row-tint-brand-edge',
}

const AssessmentScaleWidget = ({ scale }: { scale: AssessmentScale }) => (
  <div className="assessment-scale">
    <div className="assessment-scale-ranges">
      {scale.ranges.map(range => (
        <div key={range.label} className="assessment-scale-range">
          <span className={`assessment-dot dot-${range.color}`} />
          <span className="body-xs">{range.label}</span>
        </div>
      ))}
    </div>
    <span className="assessment-scale-caption body-xs">{scale.caption}</span>
  </div>
)

export const AssessmentComponentsTable = () => {
  return (
    <div className="table-wrapper">
      <table className="assessment-table">
        <thead>
          <tr>
            <th colSpan={2} className="subtitle-xs">
              Dimensions
            </th>
            <th className="subtitle-xs">Info/Reflection</th>
            <th className="subtitle-xs">Assessment</th>
          </tr>
        </thead>
        <tbody>
          {assessmentComponentsRows.map(group => (
            <Fragment key={group.pillar}>
              {group.rows.map((row, rowIndex) => (
                <tr key={`${group.pillar}-${row.rowType}`}>
                  {rowIndex === 0 && (
                    <td rowSpan={group.rows.length} className={`pillar-cell ${pillarClass[group.pillar]}`}>
                      <span className="subtitle-xs">{group.pillar}</span>
                    </td>
                  )}
                  <td className="row-type-cell">
                    <span className="subtitle-xxs">{row.rowType}</span>
                  </td>
                  <td className={`info-cell ${rowTintClass[group.pillar]}`}>
                    <div className="info-cell__inner">
                      {row.info.map(line => (
                        <p key={line} className="body-xs">
                          {line}
                        </p>
                      ))}
                    </div>
                  </td>
                  <td className={rowTintClass[group.pillar]}>
                    <AssessmentScaleWidget scale={row.scale} />
                  </td>
                </tr>
              ))}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  )
}
